import { OnlineSalesUnauthenticated } from 'gw-edge-client';
import { selector } from 'recoil';
import { jobInfoAtom } from '../atoms/jobInfoAtom';
import { getOnsaCurrentProductSelector } from './getOnsaCurrentProductSelector';
import { isLoggedOnSelector } from './isLoggedOnSelector';
import { COVERABLE_CODE } from '../../constants/coverable';

export const holidayHomeContentCovOptionsSelector = selector<string[]>({
    key: 'holidayHomeContentCovOptionsSelector',
    get: async ({ get }) => {
        const { jobNumber, sessionId } = get(jobInfoAtom);
        const currentProduct = get(getOnsaCurrentProductSelector);
        const isLoggedOn = get(isLoggedOnSelector);

        if (currentProduct.flavourCode !== COVERABLE_CODE.prhHolidayHome) return [];

        return await OnlineSalesUnauthenticated.getPrhContentCovOptions(
            jobNumber,
            sessionId,
            currentProduct.fixedId,
            !isLoggedOn
        );
    }
});
